export const basicBoardStatus = {
  PENDING: {
    value: 'PENDING',
    style: 'badge-info',
    icon: 'ni ni-clock',
    label: 'Pending',
  },
  ACTIVE: {
    value: 'ACTIVE',
    style: 'badge-primary',
    icon: 'ni ni-check-circle',
    label: 'Convocated',
  },
  CLOSED: {
    value: 'CLOSED',
    style: 'badge-secondary',
    icon: 'ni ni-na',
    label: 'Closed',
  },
};
